import { render, staticRenderFns } from "./UrunKonumEkstraHizmet.vue?vue&type=template&id=f9997220&scoped=true"
import script from "./UrunKonumEkstraHizmet.vue?vue&type=script&lang=js"
export * from "./UrunKonumEkstraHizmet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9997220",
  null
  
)

export default component.exports